import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import ClientUserIcon from "@/Components/Icons/ClientUserIcon";
import RoleAccessIcon from "@/Components/Icons/RoleAccessIcon";
import { fetchUserAccessCounts } from "@/reducers/client_user/userAccess";

const UserAccessTypes = () => {
  const dispatch = useDispatch();
  const { typeCount } = useSelector((state) => state.userAccess);
  const { activeSubPage } = useSelector((state) => state.clientCommon);

  const IconObj = {
    roles: {
      icon: (
        <RoleAccessIcon cls={"h-[22px] w-[22px] lg:h-[25px] lg:w-[25px]"} />
      ),
      color: "text-green",
      bg: "bg-green-200",
      active: "bg-green",
      hoverBg: "hover:bg-green",
    },
    users: {
      icon: (
        <ClientUserIcon cls={"h-[22px] w-[22px] lg:h-[25px] lg:w-[25px]"} />
      ),
      color: "text-cyan",
      bg: "bg-cyan-200",
      active: "bg-cyan",
      hoverBg: "hover:bg-cyan",
    },
  };

  useEffect(() => {
    dispatch(fetchUserAccessCounts());
  }, []);

  const handleResetAllSearch = () => {
    //
  };

  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    handleResetAllSearch();
  }, [activeSubPage]);

  return (
    <div className="UserAccessTypes_Wrapper">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-5">
        {typeCount.map((ele, index) => {
          let mainObj = IconObj[ele.type];
          return (
            <Link
              to={ele.link}
              className={`group/tab inline-block w-full ${
                activeSubPage === ele.name
                  ? mainObj.active
                  : `bg-white ${mainObj.hoverBg}`
              } rounded-[14px] p-3 !decoration-none   hover:decoration-none lg:px-4 lg:py-3 xl:px-5 xl:py-4`}
              key={index}
            >
              <div className="flex items-center justify-between">
                <div
                  className={`h-[20px] w-[20px]   lg:h-[25px] lg:w-[25px] ${activeSubPage === ele.name ? "text-white" : `${mainObj.color} group-hover/tab:!text-white`}`}
                >
                  {mainObj.icon}
                </div>
                <p
                  className={`capitalize   ${
                    activeSubPage === ele.name
                      ? "text-white"
                      : "!text-txtColor group-hover/tab:!text-white"
                  } grow pl-3 text-[14px] font-semibold leading-none 2xl:text-[18px]`}
                >
                  {ele.name}
                </p>
                <div
                  className={`flex h-[36px] min-w-[44px] items-center justify-center rounded-lg px-1   lg:h-[40px] lg:min-w-[50px] 2xl:h-[44px] 2xl:min-w-[55px] ${
                    activeSubPage === ele.name
                      ? "bg-white"
                      : `${mainObj.bg} ${mainObj.color} group-hover/tab:!bg-white`
                  }`}
                >
                  <p
                    className={`${
                      activeSubPage === ele.name
                        ? mainObj.color
                        : "text-gray-600"
                    } text-[min(2vh,18px)] font-bold lg:text-[18px] 2xl:text-[20px]`}
                  >
                    {ele.value}
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default UserAccessTypes;
